/* Carte de fidélité Avelyn — tampons animés, confettis, retournement, reflet.
   Sans JS la carte s'affiche déjà dans son état final : ce script ne fait
   que mettre en scène ce que le Liquid a rendu. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function LoyaltyCard(root) {
    this.root = root;
    this.goal = parseInt(root.dataset.goal, 10) || 3;
    this.stamps = parseInt(root.dataset.stamps, 10) || 0;
    this.full = root.dataset.full === 'true';
    this.reward = root.dataset.reward === 'true';
    this.guest = root.dataset.state === 'guest';
    this.slots = Array.prototype.slice.call(root.querySelectorAll('.lc-slot'));
    this.card = root.querySelector('[data-card]');
    this.deck = root.querySelector('[data-deck]');
    this.stage = root.querySelector('.lc__stage');
    this.confetti = root.querySelector('[data-confetti]');
    this.count = root.querySelector('.lc__progress-count strong');
    this.visible = false;
    this.played = false;

    this.bindFlip();
    this.bindCopy();

    if (reduced) { root.classList.add('is-in'); return; }

    root.setAttribute('data-animate', '');
    if (this.count) this.count.textContent = '0';
    this.bindTilt();
    this.observe();
  }

  LoyaltyCard.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) { this.play(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        self.visible = e.isIntersecting;
        if (e.isIntersecting && !self.played) self.play();
      });
    }, { threshold: 0.3 }).observe(this.stage);
  };

  LoyaltyCard.prototype.play = function () {
    this.played = true;
    this.root.classList.add('is-in');
    if (this.guest) { this.demo(); return; }

    var self = this;
    var chain = wait(1250);
    this.slots.slice(0, this.stamps).forEach(function (slot, i) {
      chain = chain.then(function () { return self.press(slot, i + 1); }).then(function () { return wait(430); });
    });
    chain.then(function () {
      if (!self.full) return;
      self.celebrate();
      if (self.reward) return wait(1700).then(function () { self.flip(true); });
    });
  };

  /* Un coup de tampon : impact, éclaboussure, la carte encaisse. */
  LoyaltyCard.prototype.press = function (slot, n) {
    var self = this;
    slot.classList.add('is-stamped');
    void slot.offsetWidth;
    slot.classList.add('is-pressed');
    setTimeout(function () {
      self.card.classList.remove('is-thud');
      void self.card.offsetWidth;
      self.card.classList.add('is-thud');
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
    }, 200);
    this.progress(n);
    return wait(260);
  };

  LoyaltyCard.prototype.progress = function (n) {
    this.root.style.setProperty('--p-live', (n / this.goal).toFixed(4));
    if (this.count) this.count.textContent = n;
  };

  /* Démo visiteur : la carte se remplit, fête, s'efface, recommence. */
  LoyaltyCard.prototype.demo = function () {
    var self = this;
    var loop = function () {
      if (!self.root.isConnected) return;
      if (!self.visible) { setTimeout(loop, 800); return; }
      var chain = wait(900);
      self.slots.forEach(function (slot, i) {
        chain = chain.then(function () { return self.press(slot, i + 1); }).then(function () { return wait(620); });
      });
      chain
        .then(function () { self.root.classList.add('lc--full'); self.celebrate(); return wait(3200); })
        .then(function () {
          self.root.classList.remove('lc--full');
          self.slots.forEach(function (s) { s.classList.add('is-fading'); });
          return wait(700);
        })
        .then(function () {
          self.slots.forEach(function (s) { s.classList.remove('is-stamped', 'is-pressed', 'is-fading'); });
          self.progress(0);
          loop();
        });
    };
    loop();
  };

  /* Pétales de papier aux couleurs de la carte, lancés depuis la case cadeau. */
  LoyaltyCard.prototype.celebrate = function () {
    if (!this.confetti || !this.confetti.animate) return;
    var gift = this.slots[this.slots.length - 1];
    var box = this.stage.getBoundingClientRect();
    var g = gift.getBoundingClientRect();
    var ox = g.left + g.width / 2 - box.left - box.width / 2;
    var oy = g.top + g.height / 2 - box.top - box.height / 2;
    var styles = getComputedStyle(this.root);
    var colors = [
      styles.getPropertyValue('--lc-paper'),
      styles.getPropertyValue('--lc-stamp'),
      styles.getPropertyValue('--lc-back'),
      '#fffaf0', '#c4ae8c'
    ];
    for (var i = 0; i < 42; i++) {
      var p = document.createElement('i');
      p.style.background = colors[i % colors.length];
      if (i % 3 === 0) { p.style.width = '0.6rem'; p.style.height = '0.6rem'; p.style.borderRadius = '50%'; }
      this.confetti.appendChild(p);
      var angle = (Math.random() * 1.4 - 0.7) - Math.PI / 2;
      var power = 140 + Math.random() * 220;
      var dx = Math.cos(angle) * power * (Math.random() < 0.5 ? 1.2 : 1);
      var dy = Math.sin(angle) * power;
      var spin = (Math.random() * 720 - 360) + 'deg';
      var anim = p.animate([
        { transform: 'translate(' + ox + 'px,' + oy + 'px) rotate(0) scale(0.4)', opacity: 1 },
        { transform: 'translate(' + (ox + dx) + 'px,' + (oy + dy) + 'px) rotate(' + spin + ') scale(1)', opacity: 1, offset: 0.35 },
        { transform: 'translate(' + (ox + dx * 1.4) + 'px,' + (oy + dy + 260 + Math.random() * 120) + 'px) rotate(' + spin + ') rotateX(540deg) scale(0.9)', opacity: 0 }
      ], { duration: 2000 + Math.random() * 1200, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
  };

  LoyaltyCard.prototype.flip = function (force) {
    var on = typeof force === 'boolean' ? force : !this.root.classList.contains('is-flipped');
    this.root.classList.toggle('is-flipped', on);
    var faces = this.root.querySelectorAll('.lc-card__face');
    if (faces.length === 2) {
      faces[0].setAttribute('aria-hidden', on ? 'true' : 'false');
      faces[1].setAttribute('aria-hidden', on ? 'false' : 'true');
    }
  };

  LoyaltyCard.prototype.bindFlip = function () {
    var self = this;
    this.root.querySelectorAll('[data-flip]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.flip(); });
    });
    if (this.card && this.reward) {
      this.card.style.cursor = 'pointer';
      this.card.addEventListener('click', function () { self.flip(); });
    }
  };

  LoyaltyCard.prototype.bindCopy = function () {
    this.root.querySelectorAll('[data-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.querySelector('[data-copy-label]');
        var done = function () {
          if (!label) return;
          var initial = label.textContent;
          label.textContent = label.dataset.done;
          setTimeout(function () { label.textContent = initial; }, 1800);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(btn.dataset.copy).then(done, function () {});
      });
    });
  };

  /* Reflet + inclinaison 3D au survol (souris uniquement). */
  LoyaltyCard.prototype.bindTilt = function () {
    if (!finePointer || !this.deck) return;
    var deck = this.deck;
    var shine = this.root.querySelector('.lc-card__shine');
    var frame = null;
    this.stage.addEventListener('pointermove', function (e) {
      var r = deck.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        deck.classList.add('is-tracking');
        deck.style.setProperty('--ry', ((x - 0.5) * 14).toFixed(2) + 'deg');
        deck.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
        if (shine) {
          shine.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          shine.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        }
      });
    });
    this.stage.addEventListener('pointerleave', function () {
      deck.classList.remove('is-tracking');
      deck.style.setProperty('--rx', '0deg');
      deck.style.setProperty('--ry', '0deg');
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-loyalty]').forEach(function (el) {
      if (el.__lc) return;
      el.__lc = new LoyaltyCard(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
